import {
    ReCaptchaVerification,
    GOOGLE_TYPE,
} from '@patsnap-utils/captcha-verification';
import { onMounted } from 'vue';

export const GOOGLE_CAPTCHAID_INVISIBLE = import.meta.env.VITE_GOOGLE_CAPTCHAID_INVISIBLE;

export const GOOGLE_ERROR_MESSAGE = {
    recaptcha_token: 'connected_failed_from_google_recapcha_ui',
};

export const CLOSE = 'close';

export function useCaptcha() {
    let captchaVerification: ReCaptchaVerification;

    async function verify() {
        try {
            const data = await captchaVerification.captchaValidate();
            return data;
        } catch (e) {
            // @ts-ignore
            if (e.type === CLOSE) {
                return CLOSE;
            }
            return GOOGLE_ERROR_MESSAGE;
        }
    }

    onMounted(() => {
        captchaVerification = new ReCaptchaVerification({
            type: GOOGLE_TYPE,
            id: GOOGLE_CAPTCHAID_INVISIBLE,
            lang: 'en',
            obj: { outside: true },
        });
    });

    return {
        verify,
    };
}
